import { render, staticRenderFns } from "./ListProfileWhatsapp.vue?vue&type=template&id=38dc87eb&scoped=true"
import script from "./ListProfileWhatsapp.vue?vue&type=script&lang=js"
export * from "./ListProfileWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dc87eb",
  null
  
)

export default component.exports